import React from 'react';
import CourseForm from './CourseForm';
// import { useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';

const CourseFormPage = () => {
//   const navigate = useNavigate();

  const handleCourseSubmit = (values) => {
    // Create a new course (this would normally go to an API)
    const newCourse = {
      id: Date.now(),
      title: values.title,
      viewed: false,
      uploadDate: new Date().toISOString().split('T')[0],
    };
    
    // Store in localStorage to access from the main page
    const existingCourses = JSON.parse(localStorage.getItem('courses') || '[]');
    localStorage.setItem('courses', JSON.stringify([...existingCourses, newCourse]));
    
    // Store added course details in localStorage
    localStorage.setItem('addedCourse', JSON.stringify(values));
    
    // Show success message
    // toast.success("Course added successfully!");
    
    // Redirect to home page
    // navigate('/');
  };

  return (
    <div className="container py-4">
      {/* <div className="card shadow-sm mb-4">
        <div className="card-body">
          <h2 className="fs-4 fw-semibold">Add Course</h2>
        </div>
      </div> */}
      
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <CourseForm 
            onSubmit={handleCourseSubmit}
            // onCancel={() => navigate('/')}
          />
        </div>
      </div>
    </div>
  );
};

export default CourseFormPage;